import { useTranslations } from '@utils/i18n-to-migrate/useTranslations'
import type React from 'react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

export const Toaster: React.FC<ToasterProps> = (props) => {
  const { t } = useTranslations()

  return (
    <Sonner
      theme="light"
      position="bottom-center"
      className="toaster group"
      icons={{ error: <></> }}
      closeButton
      containerAriaLabel={t('sonner.ariaLabel')}
      toastOptions={{
        unstyled: true,
        closeButtonAriaLabel: t('sonner.closeButtonAriaLabel'),
        classNames: {
          toast:
            'group flex w-full max-w-[388px] items-start gap-2 rounded-md border border-viken-rock-200 bg-white pl-4 pr-6 py-4 shadow-lg',
          title: 'text-sm font-semibold text-viken-dusk-900',
          description: 'text-sm text-viken-dusk-900/90',
          actionButton:
            'ml-auto shrink-0 whitespace-nowrap rounded-full border border-viken-rock-200 bg-transparent px-3 py-1.5 text-sm font-medium text-viken-dusk-900 hover:bg-viken-rock-100',
          cancelButton:
            'rounded-full border border-viken-rock-200 bg-transparent px-3 py-1.5 text-sm font-medium text-viken-dusk-900 hover:bg-viken-rock-100',
          closeButton:
            'absolute right-2 top-2 rounded-md p-1 text-viken-dusk-900/50 opacity-0 transition-opacity hover:text-viken-dusk-900 focus:opacity-100 focus:outline-none focus:ring-2 focus:ring-viken-dusk-900/20 group-hover:opacity-100',
          error:
            '!border-0 !bg-viken-lingon-500 [&_[data-title]]:!text-white [&_[data-description]]:!text-white/90 [&_[data-close-button]]:!text-white/50 [&_[data-close-button]:hover]:!text-white [&_[data-button]]:!border-white/30 [&_[data-button]]:!text-white',
        },
      }}
      {...props}
    />
  )
}
